import { getApiErrorCode } from "../../utils/apiError";

type Raw = Record<string, unknown>;
const dataOf = (e: unknown): Raw =>
  ((e as { response?: { data?: Raw } } | undefined)?.response?.data ??
    {}) as Raw;
const HAS_TZ = /(Z|[+-]\d{2}:?\d{2})$/;
const BRT_OFFSET_MS = 3 * 3_600_000;

/**
 * Instante de um ISO do BE. Sem fuso, o horário é de Brasília (o BE grava em BRT, `TZ=America/Sao_Paulo`).
 * Devolve NaN para texto inválido.
 */
export function parseBrt(iso: string): number {
  const s = iso.trim().replace(" ", "T");
  return HAS_TZ.test(s) ? Date.parse(s) : Date.parse(`${s}Z`) + BRT_OFFSET_MS;
}

/** "DD/MM" no relógio de Brasília (UTC−3 fixo, sem horário de verão desde 2019). */
export function brtDayMonth(iso: string): string {
  const t = parseBrt(iso);
  if (Number.isNaN(t)) return `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
  const b = new Date(t - BRT_OFFSET_MS);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(b.getUTCDate())}/${pad(b.getUTCMonth() + 1)}`;
}

/**
 * 409 `PACKAGE_NOT_EDITABLE` com `reason: 'expired'` (§8.3). O BE achata o `extra` no corpo
 * (`{code, message, reason, expiredAt}`); `extra` aninhado também é aceito. Não existe `PACKAGE_EXPIRED`.
 */
export function expiredInfoOf(error: unknown): { expiredAt: string } | null {
  if (getApiErrorCode(error) !== "PACKAGE_NOT_EDITABLE") return null;
  const data = dataOf(error);
  const extra = (
    data.extra && typeof data.extra === "object" ? data.extra : {}
  ) as Raw;
  const reason = data.reason ?? extra.reason;
  const expiredAt = data.expiredAt ?? extra.expiredAt;
  return reason === "expired" && typeof expiredAt === "string" && expiredAt
    ? { expiredAt }
    : null;
}

/** Mensagem da empresa (G2 item 20). */
export const expiredMessage = (expiredAt: string) =>
  `Pacote expirado em ${brtDayMonth(expiredAt)}; peça a reabertura à Operação.`;

export const isExpiredRow = (row: { status?: string } | null | undefined) =>
  row?.status === "expired";
